import React from "react";

function ArrowUpIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18.828"
      height="18.828"
      version="1.1"
      viewBox="466.386 1178.836 18.828 18.828"
      style={{ WebkitPrintColorAdjust: "exact" }}
    >
      <g className="feather feather-arrow-up">
        <path
          fill="none"
          stroke="#434241"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M475.8 1195.25v-14"
        ></path>
        <path
          fill="none"
          stroke="#434241"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M468.8 1188.25l7-7 7 7"
        ></path>
      </g>
    </svg>
  );
}

export default ArrowUpIcon;
